<template>
  <transition
    :name="hasTransition ? 'slide-and-appear' : 'no-transition'"
    @after-enter="afterEnter"
  >
    <div
      v-if="isVisible || isTemporarilyVisible"
      class="slide-content__block"
      :class="{
        'slide-content__block--temp-visible': isTemporarilyVisible,
      }"
    >
      <slot />
    </div>
  </transition>
</template>

<script>
import { onMount } from '@/helpers/events'

export default {
  name: 'SlideContentBlock',

  data() {
    return {
      isVisible: false, // controlled by SlideContent.vue
      isTemporarilyVisible: false,
      timeoutForIsTemporarilyVisible: null,
      hasTransition: false, // controlled by SlideContent.vue
      timeoutForHasTransition: null,
    }
  },

  watch: {
    hasTransition: {
      immediate: true,
      handler() {
        if (!this.hasTransition) {
          clearTimeout(this.timeoutForHasTransition)
          this.timeoutForHasTransition = setTimeout(() => (this.hasTransition = true), 2000)
          this.afterEnter()
        }
      },
    },

    isTemporarilyVisible: {
      immediate: true,
      handler() {
        if (this.isTemporarilyVisible) {
          clearTimeout(this.timeoutForIsTemporarilyVisible)
          this.timeoutForIsTemporarilyVisible = setTimeout(
            () => (this.isTemporarilyVisible = false),
            500
          )
        }
      },
    },
  },

  methods: {
    async getBlockHeight() {
      await onMount(this)

      if (!this.isVisible) {
        this.isTemporarilyVisible = true
        await this.$nextTick()
      }
      const offsetHeight = this.$el.offsetHeight

      return offsetHeight
    },

    afterEnter() {
      if (this.isTemporarilyVisible) return
      if (this.$parent) this.$parent.onBlockAnimationComplete()
    },
  },
}
</script>

<style lang="scss" scoped>
@import './slide-content-settings';

.slide-content {
  &__block {
    position: relative;
    font-size: $font-size-normal;

    &--temp-visible {
      position: absolute;
      left: -99999px;
    }
  }
}

.slide-and-appear-enter,
.slide-and-appear-leave-to {
  opacity: 0;
  transform: translateY(30px);
  z-index: 1;
}

.slide-content__block ~ .slide-and-appear-enter,
.slide-content__block ~ .slide-and-appear-leave-to {
  z-index: 2;

  .slide-content--slide-and-appear & {
    transform: translateX(100%);
  }

  .slide-content--rolling & {
    transform: translateY(-30px);
  }
}

.slide-and-appear-enter-active,
.slide-and-appear-leave-active {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  transition:
    opacity $transition-time ease-in-out,
    transform $transition-time $transition-cubic;
}
</style>
